import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_play_fill",
  "use": "icon-ic_play_fill-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_play_fill\">\n<g id=\"icon-ic_play_fill_ic_play_fill\">\n<path id=\"icon-ic_play_fill_Vector\" d=\"M14.9445 9.3333C15.3889 9.66663 15.3889 10.3333 14.9445 10.6666L5.50005 17.75C4.95069 18.162 4.16672 17.77 4.16672 17.0833L4.16672 2.91663C4.16672 2.22993 4.95069 1.83794 5.50006 2.24997L14.9445 9.3333Z\" fill=\"#666666\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol